import { Reducer } from 'interfaces'
import {
  CCOnboardingAcceptAction,
  CCOnboardingInitiateAction,
  GetCCOnboardingStateAction,
  GetCCStateAction,
  PatchCCOnboardingPropsAction,
} from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { WsMessageAction } from 'actions/webSocketActions'

export const ccOnboardingReducer: Reducer<CreditCardDataState['onboarding']> = (prevState = null, action) => {
  switch (action.type) {
    case WsMessageAction.type: {
      if (action.payload.event !== 'credit_card_onboarding_changed') {
        return prevState
      }

      const { person_data, ...restResponse } = action.payload.data.onboarding

      return restResponse
    }

    case CCOnboardingAcceptAction.type:
    case GetCCOnboardingStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }
      const { person_data, ...restResponse } = action.payload.response
      return restResponse
    }

    case CCOnboardingInitiateAction.type:
    case PatchCCOnboardingPropsAction.type: {
      if (action.meta !== 'success' || prevState === null) {
        return prevState
      }

      const { person_data, ...restResponse } = action.payload.response

      return {
        ...prevState,
        ...restResponse,
      }
    }

    case GetCCStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return {
        ...prevState,
        ...action.payload.response.onboarding,
      }
    }
  }
  return prevState
}
